<template>
  <div>
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbar_timeout"
      :color="snackbar_color"
      :top="true" >
      {{ snackbar_message }}
    </v-snackbar>

    <v-card flat class="mt-5" >
      <v-card-title>
        <h6 class="primary--text">Liste des langues</h6>
        <v-spacer></v-spacer>

        <v-btn rounded color="primary" class="text-capitalize" v-if="$can('create languages')">
          <export-excel
            :data = "languages"
            name = "Langues.xls"
            :export-fields ="languages_fields">
            Exporter
            <v-icon right>mdi-share-outline</v-icon>
          </export-excel>
        </v-btn>
        <v-spacer></v-spacer>

        <v-dialog v-model="dialog_edit" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn rounded color="primary" dark class="mb-2" v-on="on" v-if="$can('create languages')">
              Ajouter <v-icon right>mdi-plus-circle-outline</v-icon>
          </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.name" label="Nom du langue" solo></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="info" rounded @click="dialog_edit = false">Fermer</v-btn>
              <v-btn color="primary" rounded @click="save">Enregistrer</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-spacer></v-spacer>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Rechercher un langue"
          single-line
          solo
          hide-details>
        </v-text-field>

      </v-card-title>
    </v-card>

  <v-data-table
    :headers="headers"
    :items="languages"
    :loading="loading"
    loading-text="Loading..."
    sort-by="name"
    :search="search"
    class="elevation-1">

    <!-- <template v-slot:items="props">
      <td >{{ props.item.name }} </td>
      <td >{{ props.item.country.name}}</td>
    </template> -->

    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
        v-if="$can('edit languages')">
        mdi-pencil-outline
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
        v-if="$can('delete languages')">
        mdi-trash-can-outline
      </v-icon>
    </template>

  </v-data-table>


  <v-layout row justify-center>
    <v-dialog
      v-model="dialog_deletion"
      max-width="290">
      <v-card>
        <v-card-title class="headline">Suppression</v-card-title>
        <v-card-text class="text-center">
         Etes-vous sûr de vouloir supprimer ce langue ?
        </v-card-text>

        <v-card-actions>

          <v-btn
            color="orange"
            rounded
            @click="dialog_deletion = false">
             <span class="white-couleur">Non</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            rounded
            @click="delLanguage()">
            Oui
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>

  </div>
</template>

<script>
import Permissions from '~/mixins/Permissions';

export default {
  name: 'settings-language',
  mixins: [Permissions],
  data: () => ({
    del_language: null,
    del_index: null,
    search: '',
    loading: false,
    dialog_edit: false,
    dialog_deletion: false,
    headers: [
      { text: 'Langue', value: 'name' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    languages_fields : {
      "Langue": "name",
    },
    snackbar: false,
    snackbar_message: '',
    snackbar_timeout: 5000,
    snackbar_color: '',

    editedIndex: -1,
    editedItem: {
      name: '',
      country_id: null,
    },
    defaultItem: {
      name: '',
      country_id: null,
    },

  }),

  created () {
    this.loading = true
    this.fetchUtils();
    this.loading = false
  },

  computed: {
    pays () { return this.$store.getters.countries; },
    languages () { return this.$store.getters.languages; },
    formTitle () {
        return this.editedIndex === -1 ? 'Nouvelle langue' : 'Editer la langue'
      },
  },

  watch: {
      dialog (val) {
        val || this.close()
      },
    },

  methods: {
    fetchUtils () {
      this.$store.dispatch("fetchCountries");
      this.$store.dispatch("fetchLanguages");
    },

    editItem (item) {
      this.editedIndex = this.languages.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_edit = true
    },

    deleteItem (item) {
      this.del_index = this.languages.indexOf(item);
      this.dialog_deletion = true;
      this.del_language = item;
    },

    close () {
      this.dialog_edit = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async save () {
      if (this.editedIndex > -1) {
        await this.$store.dispatch("updateLanguage", this.editedItem);
        this.snackbar = true;
        this.snackbar_color = 'success';
        this.snackbar_message = "Langue édité avec succès !";
      }
      else {
        await this.$store.dispatch("createLanguage", this.editedItem);
        this.snackbar = true;
        this.snackbar_color = 'success';
        this.snackbar_message = "Langue enregistré avec succès !";
      }
      this.close();
    },


    async delLanguage(){
      await this.$store.dispatch("deleteLanguage", this.del_language);
      this.dialog_deletion = false;
      this.snackbar = true;
      this.snackbar_color = 'success';
      this.snackbar_message = "Langue supprimé avec succès !";
    },

  }
};
</script>

<style scoped>
.white-couleur{
  color: white;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/pages/settings/languages/list.vue